import {
  AlertPosition,
  SubmitButtonWithAlert,
  UpdateForm
} from '../../../../../components'
import { AlertProvider } from '../../../../../contexts'
import { SAVE_MEMBERSHIP_CARD } from '../../../../../graphql'
import { MembershipCardInput } from '../../../../../utils/classes/graphql'
import { MembershipCardInfoProps } from './membership-card'

export const SaveMembershipCardForm = ({
  membershipCard
}: MembershipCardInfoProps) => {
  const createVariables = () => ({
    membershipCard: {
      jasenkortti: 'U',
      jasenkortin_nimi: 'Uusi',
      jasenkortin_tyyppi: 'U',
      jasenkortin_tyyppi_nimi: 'Muovi',
      kortin_tilaus: true
    }
  })

  const membershipCardValues: MembershipCardInput = {
    ...membershipCard
  }

  return (
    <AlertProvider>
      <UpdateForm
        query={SAVE_MEMBERSHIP_CARD}
        createVariablesFn={createVariables}
        formikProps={{
          initialValues: membershipCardValues
        }}
        submitCheckerProps={{
          successMessageId:
            'pages.ownInfoPage.membership.membershipCard.save.success',
          errorMessageId:
            'pages.ownInfoPage.membership.membershipCard.save.error'
        }}
      >
        <SubmitButtonWithAlert
          alertProps={{
            alertPosition: AlertPosition.LEFT,
            variant: 'outlined'
          }}
          buttonProps={{
            checkIsDirty: false,
            translationId:
              'pages.ownInfoPage.membership.membershipCard.button.orderNew'
          }}
        />
      </UpdateForm>
    </AlertProvider>
  )
}
